import styled from 'styled-components';
import Button from '../atoms/Buttons';

const ActivateSoundButton = styled(Button)`
  position: absolute; top: 16px; right: 16px; z-index: 4;
  pointer-events: auto; padding: 10px 16px;
  font-size: 14px; letter-spacing: .03em;
`;

export default ActivateSoundButton;
